var exports = {
  "B": "x93eb46d8--f9315a--offers-list",
  "U": "x93eb46d8--f9315a--pagination-adjustments",
};

module.exports = exports;
